require('jquery-match-height');

import enquire from 'enquire.js';

document.addEventListener('DOMContentLoaded', () => {
	let postCarouselRow = $('.post-carousel-fw > .row');
	if (postCarouselRow.length > 0) {
		postCarouselRow.on('init reInit afterChange', function(event, slick, currentSlide){
			$('.post-info-card > .content').matchHeight();
		});
		postCarouselRow.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
			]
		});
	}

	let postInfoCardMini = $('.post-info-card-mini > .content');
	if (postInfoCardMini.length > 0) {
		postInfoCardMini.matchHeight();
	}
	
	let logoSliderfw = $('.logo-slider-fw .slider');
	if (logoSliderfw.length > 0) {
		logoSliderfw.slick({
			arrows: false,
			autoplay: true,
			draggable: false,
			pauseOnHover: false,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 6,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 300,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				}
			]
		});
	}
	
	let testimonialSlider = $('.testimonial-slider');
	if (testimonialSlider.length > 0) {
		testimonialSlider.slick({
			arrows: false,
			dots: true,
			autoplay: false,
		});
	}

	let sectorCarousel = $('.sector-carousel');
	if (sectorCarousel.length > 0) {
		sectorCarousel.slick({

			slidesToShow: 1,
			arrows: true,
			dots: false,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 1500,
					settings: {
						slidesToShow: 5,
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 99200,
					settings: {
						slidesToShow: 3,
						centerMode: true,
						centerPadding: '90px',
					}
				},
				// {
				// 	breakpoint: 300,
				// 	settings: {
				// 		slidesToShow: 1,
				// 		slidesToScroll: 1
				// 	}
				// }
			]
		});
		$('.sector-carousel-slide').matchHeight();
	}
	// tab control carousel
	let twoColumnTabSlider = $('.two-column-tab-slider');
	if (twoColumnTabSlider.length > 0) {
		twoColumnTabSlider.each(function () {
			let $this = $(this);
			let $controls = $this.find('.two-column-tab-slider-controls');
			$this.find('.two-column-tab-slider-text-carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				$controls.find('li').removeClass('active-slide');
				$controls.find('li[data-indextarget="' + nextSlide + '"').addClass('active-slide');
			});
			let $textCarousel = $this.find('.two-column-tab-slider-text-carousel').slick({
				arrows: false,
				fade: true,
				infinite: false,
				asNavFor: $this.find('.two-column-tab-slider-imagecarousel'),
			});
			let $imageCarousel = $this.find('.two-column-tab-slider-imagecarousel').slick({
				arrows: false,
				fade: true,
				infinite: false,
				asNavFor: $this.find('.two-column-tab-slider-text-carousel'),
			});
			$('.two-column-tab-slider-controls').slick({
				dots: false,
				infinite: false,
				centerMode: false,
				speed: 300,
				slidesToShow: 3,
				slidesToScroll: 1,
				asNavFor: $this.find('.two-column-tab-slider-text-carousel, .two-column-tab-slider-imagecarousel'),
				responsive: [
					{
					breakpoint: 1300,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					},
					{
					breakpoint: 600,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					},
					{
					breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]
			});
			$controls.find('li').each(function () {
				$(this).on('click', function () {
					let $target = $(this).data('indextarget');
					$textCarousel.slick('slickGoTo', $target);
					$imageCarousel.slick('slickGoTo', $target);
				})
			})
		});
	}

	// column slider
	let columnSlider = $('.column-slider');
	if (columnSlider.length > 0) {
		columnSlider.slick({
			dots: true,
			appendDots: $('.slick-dot-controls'),
			dotsClass: 'slick-dots big',
			fade: true,
			prevArrow: '<i class="fas fa-angle-left"></i>',
			nextArrow: '<i class="fas fa-angle-right"></i>',
		});
	}
	
	//add-on slider
	let slideCombo = $('.slide-combo');
	if (slideCombo.length > 0) {
		slideCombo.each(function () {
			let $slider = $(this).find('.addonslider .slider');
			let $navs = $(this).find('.addon-navs');

			$slider.slick({
				dots: false,
				arrows: false,
				fade: true,
			});

			$navs.find('span[data-slide-target]').first().addClass('active');

			$navs.find('span[data-slide-target]').each(function() {
				let $control = $(this);
				let target = $control.attr('data-slide-target');
				$control.on('click', function(e) {
					e.preventDefault();
					$control.addClass('active').siblings().removeClass('active');
					$slider.slick('slickGoTo', target);
				})
			})
		})
	}
	//wavy line slider
	let wavyLineCards = $('.home-wavy-line-cards .cards-holder');
	if (wavyLineCards.length > 0) {
		enquire.register("screen and (min-width:1500px)", {
			setup: function () {
				initCurvyWaveSlder(wavyLineCards);
			},
			match: function () {
				// slider destroys itself on match, no need to do abything here
			},
			unmatch: function() {
				// reinitialise the slider on unmatch
				initCurvyWaveSlder(wavyLineCards);
			},
		});
	}
	
	let expandingCardsContainer = $('.expanding-cards-container .row');
	if (expandingCardsContainer.length > 0) {
		expandingCardsContainer.slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 300,
			autoplay: true,
			autoplaySpeed: 5000,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 992,
					settings: "unslick"
				},
				{
					breakpoint: 300,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
	}

	let postInfoSummarySlider = $('.post-info-summary-slider');
	if (postInfoSummarySlider.length > 0) {
		postInfoSummarySlider.on('init reInit afterChange', function(event, slick, currentSlide){
			$('.post-info-card > .content').matchHeight();
		});

		postInfoSummarySlider.slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 300,
			autoplay: true,
			autoplaySpeed: 5000,
			mobileFirst: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 768,
					settings: "unslick"
				}
			]
		});
	}
	
	let cardsCarousel = $('.cards-carousel');
	if (cardsCarousel.length > 0) {
		$('.cards-carousel').slick({
			dots: false,
			arrows: false,
			infinite: false,
			speed: 300,
			autoplay: true,
			autoplaySpeed: 5000,
			mobileFirst: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1200,
					settings: "unslick"
				}
			]
		});
	}
});

function initCurvyWaveSlder(selector) {
	selector.slick({
		dots: false,
		arrows: true,
		infinite: true,
		speed: 300,
		autoplay: true,
		autoplaySpeed: 5000,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 1500,
				settings: "unslick"
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 300,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
}